@if (mission) {
  <table>
    <tr>
      <th colspan="2">{{ 'MISSION.INFO.UNIT_CATALYST_CHARACTERISTICS' | translate | uppercase }}</th>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.UNIT' | translate }}</td>
      <td>{{ mission.unitName }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.UNIT_TYPE' | translate }}</td>
      <td>{{ mission.unitypeName }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.CATALYST_WEIGHT' | translate }}</td>
      <td>{{ mission.catalystWeight | number : '1.0-0' }} {{ mission.tonUom }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.CATALYST_MANUFACTURER' | translate }}</td>
      <td>{{ mission.catalystProvider }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.CATALYST_NAME' | translate }}</td>
      <td>{{ mission.catalystName }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.SULFIDING_RESPONSIBLE' | translate }}</td>
      <td>{{ mission.catalystproviderName }}</td>
    </tr>
    @for (reactor of reactors; track reactor; let i = $index) {
      <tr>
        <td>{{ i === 0 ? ('MISSION.INFO.REACTOR_BEDS' | translate) : '' }}</td>
        <td>{{ reactor.reactorName }} / {{ reactor.bedNumber == null ? '?' : reactor.bedNumber }}</td>
      </tr>
    }
    <tr>
      <td>{{ 'MISSION.INFO.CATALYST_FIXABLE_SULFUR' | translate }}</td>
      <td>{{ mission.catalystStoechioSulfur }} %</td>
    </tr>
  </table>
  <table>
    <tr>
      <th colspan="2">{{ 'MISSION.INFO.UNIT_WORKING_CONDITIONS' | translate | uppercase }}</th>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.FEEDSTOCK_FLOWRATE' | translate }}</td>
      <td>{{ mission.feedstockFlowrate | number : '1.0-2' }} {{ mission.cubicFlowrateUom }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.FEEDSTOCK_TYPE' | translate }}</td>
      <td>{{ mission.feedstocknatureName }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.FEEDSTOCK_SULFUR' | translate }}</td>
      <td>{{ mission.feedstockSulfurcontent }} %</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.FEEDSTOCK_RECYCLING' | translate }}</td>
      <td>{{ (mission.feedstockRecycling ? 'YES' : 'NO') | translate }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.GAS_RECYCLING' | translate }}</td>
      <td>{{ (mission.H2Recycling ? 'YES' : 'NO') | translate }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.UNIT_PRESSURE' | translate }}</td>
      <td>{{ mission.unitWorkingPressure | number : '1.0-2' }} {{ mission.pressureUom }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.H2_FLOWRATE' | translate }}</td>
      <td>{{ mission.H2Flowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</td>
    </tr>
  </table>
  <table>
    <tr>
      <th colspan="2">{{ 'MISSION.INFO.DMDS_INJECTION' | translate | uppercase }}</th>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.CATALYST_STOECHIO' | translate }}</td>
      <td>{{ mission.catalystStoechioDMDS }} %</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.MIN_FLOWRATE' | translate }}</td>
      <td>{{ mission.DMDSExpectedMinFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.MAX_FLOWRATE' | translate }}</td>
      <td>{{ mission.DMDSExpectedMaxFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</td>
    </tr>
    <tr>
      <td>{{ 'MISSION.INFO.INJECTION_PRESSURE' | translate }}</td>
      <td>{{ mission.unitDMDSInjectionPointPressure | number : '1.0-2' }} {{ mission.pressureUom }}</td>
    </tr>
    <tr>
      <td class="subtitle">{{ 'PRODUCT.LABEL' | translate }}</td>
      <td class="subtitle">{{ 'MISSIONS.ORDERED_QUANTITY' | translate }}</td>
    </tr>
    @for (product of mission.products; track product) {
      <tr>
        <td>{{ product.productName }}</td>
        <td>{{ product.productmissionLoadedExpectedMassTotal }} {{ mission.weightUom }}</td>
      </tr>
    }
  </table>
}
